import PropTypes from "prop-types";

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

export const CustomSelect = ({
  id,
  label,
  fullWidth = true,
  options,
  helperText,
  sx,
  value,
  onChange,
  disabled,
  emptyLabel = "Pilih",
  disableEmpty = true,
  ...props
}) => {

  return (
    <FormControl
      fullWidth={fullWidth}
      variant="standard"
      sx={{ ...(label && { pt: 3.5 }), ...sx }}
      disabled={disabled}
      {...props}
    >
      {label && (
        <InputLabel
          shrink
          disabled={disabled}
          sx={{
            fontSize: "0.875rem",
            lineHeight: "1.125rem",
            transform: "scale(1)",
          }}
          {...{ htmlFor: id }}
        >
          {label}
        </InputLabel>
      )}
      <Select
        labelId={id}
        value={value ?? ""}
        onChange={onChange}
        disabled={disabled}
        displayEmpty={true}
      >
        <MenuItem value="" disabled={disableEmpty}>
          <Typography color={disableEmpty ? "text.disabled" : "inherit"}>
            {emptyLabel}
          </Typography>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

CustomSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ).isRequired,
  helperText: PropTypes.string,
  sx: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  emptyLabel: PropTypes.string,
  disableEmpty: PropTypes.bool,
};
